let data = {
  columns: [
    { label: 'Data/hora', field: 'created_at', sortable: false, filter: 'TO_DATE_TIME' },
    { label: 'Endereço IP', field: 'ip', sortable: false },
    { label: 'Tipo de acesso', field: 'browser', sortable: false, class: 'expand' }
  ],
  rows: []
}

export default data
